export enum RoleTypeEnum {
    Admin = 'Admin',
    ExternalUser = 'external-user',
    FleetPerformanceAnalyst = 'FleetPerformanceAnalyst',
    OtherOdfjellUser = 'OtherOdfjellUser',
    PortOperator = 'PortOperator',
    ShipOperator = 'ShipOperator',
    ShipUser = 'ShipUser',
    Unknown = 'Unknown',
}
